export const RechargeType = {
    //addrecarge secton

    setBrowsePlans: 'setBrowsePlans',

    setShowRecargeSection: 'setShowRecargeSection',
    setCurrentOpertaor: 'setCurrentOpertaor',
    setCurrenntCircle: 'setCurrenntCircle',
    setRechrgeMobile: 'setRechrgeMobile',
    selectedRechargableAmnt: 'selectedRechargableAmnt',
    selectedRechargableAmnt1: 'selectedRechargableAmnt1',
    setRechargeType: 'setRechargeType',

    //dth cutomer id
    setDTHCustomerId: 'setDTHCustomerId',

    //recharge transfer
    setMoneyTransferTotalAmount1: 'setMoneyTransferTotalAmount1',
    setMoneyTransferSurChargeAmount1: 'setMoneyTransferSurChargeAmount1',
    setOrderId1: 'setOrderId1',
    setAmount1: 'setAmount1',
    setCreteOrderReq1: 'setCreteOrderReq1',
    setCreateOrderRes1: 'setCreateOrderRes1',

    //recharge details
    setRechargeTxhHistory: 'setRechargeTxhHistory',
    setTxnAmount1: 'setTxnAmount1',
    setTxnsurcharge1: 'setTxnsurcharge1',
    setTxntotalAmoun1: 'setTxntotalAmoun1',
    setMoneyTransferProgress1: 'setMoneyTransferProgress1',
    setStatusEnqResponse1: 'setStatusEnqResponse1',

    setFilterStartDate:'setFilterStartDate',
    setFilterEndDate:'setFilterEndDate',
    RESET: "RESET"
}